import { render, staticRenderFns } from "./zhiyijiluDialog.vue?vue&type=template&id=4138ae8e&"
import script from "./zhiyijiluDialog.vue?vue&type=script&lang=ts&"
export * from "./zhiyijiluDialog.vue?vue&type=script&lang=ts&"
import style0 from "./zhiyijiluDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports